module.exports = __webpack_public_path__ + "img/progress.750fc7f7.gif";